module.exports = __webpack_public_path__ + "static/media/5_18.8afcad21.png";